import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ec4e5f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "FrontPage" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "News NormalPaddings" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Enkeleitä luokseni"),
  /*#__PURE__*/_createElementVNode("p", null, " Kun sinulla on pilke silmäkulmassa, yksi hymy, halaus, kiitoksen sana, myötätunto, positiivisuus... Ne kantavat tätä elämää eteenpäin valon tiellä ja lähettävät enkeleille vetovoimaa luoksesi. "),
  /*#__PURE__*/_createElementVNode("p", null, "- ote Enkelin Esiliinan kirjasta: Taivaan Lahja.")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "News2 NormalPaddings" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://enkelinesiliina.fi:8080/images/wide/0071fde0-cab8-4401-b5fd-14cc2e836a16.png",
    alt: "Sydämesi ääni"
  })
], -1))
const _hoisted_4 = {
  id: "yhteys",
  class: "Contact NormalPaddings"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Yhteys", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Ajanvaraus: 041-5303102 / Margit", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Margit ottaa vastaan ajanvarauksia ainoastaan maanantaisin klo 9-22. ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Eläinten hoidosta: ilmoita tekstiviestillä asiasi, me vastaamme ajan, jolloin voit soittaa. Hoito tulee puhelimitse. ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import HomeButton from "../components/HomeButton.vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _hoisted_6,
      _hoisted_7,
      _hoisted_8,
      _hoisted_9,
      _createVNode(HomeButton)
    ])
  ]))
}
}

})